export const extractYoutube = ({ path }) => {
  try {
    const parsedUrl = new URL(path);
    console.log("parsedUrl :>> ", parsedUrl);
    if (parsedUrl.hostname === "youtu.be") {
      return parsedUrl.pathname.substring(1);
    }
    if (
      parsedUrl.pathname.startsWith("/live/") ||
      parsedUrl.pathname.startsWith("/shorts/")
    ) {
      return parsedUrl.pathname.split("/")[2];
    }

    // กรณี URL รูปแบบ youtube.com/watch
    if (parsedUrl.pathname === "/watch") {
      return parsedUrl.searchParams.get("v");
    }

    if (parsedUrl.pathname.startsWith("/embed/")) {
      return parsedUrl.pathname.split("/")[2];
    }
    throw new Error("Invalid YouTube URL format");
  } catch (error) {
    console.error("Failed to extract videoId:", error.message);
    return null;
  }
};
